import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import resx from '../../utilities/resx';
import { LOGGLY_LEVEL_ERROR, RESX_GLOBAL } from '../../Constants';
import { withMessage } from '../Common/Message';
import ContentSubscriptionService from '../../API/ContentSubscription';
import LogglyLogger from '../../API/Loggly';

const ReblastNotificationToggle = ({ message}) => {
	const [isSubscribed, setIsSubscribed] = useState(false);
	const [buttonClass, setButtonClass] = useState('');
	const [buttonText, setButtonText] = useState('');
	const [mixPanelType, setMixPanelType] = useState('');
	const [notificationStatus, setNotificationStatus] = useState('');
	const [visibility, setVisibility] = useState('');
	const contentId = window.location.pathname.slice(9);

	const getNotificationConfig = () => {
		setButtonClass('submitting');
		ContentSubscriptionService.getNotificationSetting(contentId)
			.then(response => {
				if (!response.data.Success) {
					throw new Error(response.data.Message);
				}

				setVisibility('visible');
				const { IsSubscribed } = response.data.Data;
				setIsSubscribed(IsSubscribed);
				if (IsSubscribed) {
					setButtonClass('is-on');
					setNotificationStatus(resx(RESX_GLOBAL, 'NOTIFICATION_ON_TEXT'));
					setButtonText(resx(RESX_GLOBAL, 'TURN_OFF_NOTIFICATION_TEXT'));
					setMixPanelType('off');
				} else {
					setButtonClass('is-off');
					setNotificationStatus(resx(RESX_GLOBAL, 'NOTIFICATION_OFF_TEXT'));
					setButtonText(resx(RESX_GLOBAL, 'TURN_ON_NOTIFICATION_TEXT'));
					setMixPanelType('on');
				}
			})
			.catch(error => {
				let errorMessage;

				if (error.response && error.response.status) {
					errorMessage = resx(RESX_GLOBAL, 'ERROR_GET_NOTIFICATION_SETTINGS');
				} else {
					errorMessage = error.message;
				}

				message.addMessage({ message: errorMessage, type: 'error' });

				LogglyLogger.add(LOGGLY_LEVEL_ERROR, 'ContentSubscriptionService.getNotificationSetting from Reblast Details Page', error);
			});
	};

	const toggleNotification = () => {
		setButtonClass('submitting');

		const data = {
			IsSubscribed: !isSubscribed,
			contentId: contentId
		};

		ContentSubscriptionService.setNotificationSetting(data)
			.then(response => {
				if (!response.data.Success) {
					throw new Error(response.data.Message);
				}

				if (isSubscribed) {
					setIsSubscribed(false);
					setButtonClass('is-off');
					setNotificationStatus(resx(RESX_GLOBAL, 'NOTIFICATION_OFF_TEXT'));
					setButtonText(resx(RESX_GLOBAL, 'TURN_ON_NOTIFICATION_TEXT'));
					setMixPanelType('on');
				} else {
					setIsSubscribed(true);
					setButtonClass('is-on');
					setNotificationStatus(resx(RESX_GLOBAL, 'NOTIFICATION_ON_TEXT'));
					setButtonText(resx(RESX_GLOBAL, 'TURN_OFF_NOTIFICATION_TEXT'));
					setMixPanelType('off');
				}
			})
			.catch(error => {
				let errorMessage;

				if (error.response && error.response.status) {
					errorMessage = resx(RESX_GLOBAL, 'ERROR_SET_NOTIFICATION_SETTINGS');
				} else {
					errorMessage = error.message;
				}

				message.addMessage({ message: errorMessage, type: 'error' });

				LogglyLogger.add(LOGGLY_LEVEL_ERROR, 'ContentSubscriptionService.setNotificationSetting from Reblast Details Page', error);
			});
	};

	useEffect(() => {
		getNotificationConfig();
	}, []);

	return (
		visibility &&
		<div className='re-notification-toggle re-container re-container-outer'>
			{notificationStatus && (
				<React.Fragment>
					<h2 className="re-text-md re-notification-toggle-header">{resx(RESX_GLOBAL, 'TOGGLE_NOTIFICATION_TITLE_TEXT')}</h2>
					<p>
						{resx(RESX_GLOBAL, 'REBLAST_NOTIFICATION_TEXT')}
						<span className="email-notification-status"> {notificationStatus}</span>
					</p>
					<a
						href="#"
						className={`re-btn re-btn-full-width re-btn-grey btn-toggle-notification ${buttonClass}`}
						onClick={() => toggleNotification()}
						data-mixpanel-name="Intent"
						data-mixpanel-type={`notification ${mixPanelType}`}
					>
						{buttonText}
					</a>
				</React.Fragment>
			)}
		</div>
	);
};

ReblastNotificationToggle.propTypes = {
	message: PropTypes.object
};

export default withMessage(ReblastNotificationToggle);
